export default "__VITE_ASSET__C7G_pMAB__"